var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/bind-html/bind-html.html';
var html = "<div ng-bind-html=$ctrl.content class=ckeditor-data ng-class=\"{'clamp-text': $ctrl._isClampText}\"> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/bind-html/bind-html.html
// module id = 902
// module chunks = 0